import { render } from "./ScoreInfoMobile.vue?vue&type=template&id=51005ef4&scoped=true"
import script from "./ScoreInfoMobile.vue?vue&type=script&lang=js"
export * from "./ScoreInfoMobile.vue?vue&type=script&lang=js"

import "./ScoreInfoMobile.vue?vue&type=style&index=0&id=51005ef4&scoped=true&lang=css"
import "./ScoreInfoMobile.vue?vue&type=style&index=1&id=51005ef4&lang=css"
import "./ScoreInfoMobile.vue?vue&type=style&index=2&id=51005ef4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51005ef4"]])

export default __exports__